module.exports = __webpack_public_path__ + "img/no-sessions.33b1942c.svg";